import React from 'react'

const StyledH2Heading = ({ regularContent, regularFontColor }) => {
  return (
    <h2 className={`${regularFontColor} font-display tracking-tight text-2xl md:text-3xl lg:text-[40px] leading-tight font-semibold`}>{regularContent}</h2>
  )
}

export default StyledH2Heading
